// @flow
import styled from 'styled-components';
import InputTheme from '../../input/theme';
/*::
import type { Node } from 'react';
import type { FileInputThemeType } from '..';
*/

var FileInputTheme
/*: FileInputThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "jab3ea-0"
  })(["position:relative;width:100%;height:5.6rem;"]),
  Label: styled.label.withConfig({
    displayName: "theme__Label",
    componentId: "jab3ea-1"
  })(["cursor:text;height:100%;width:100%;"]),
  Input: Object.assign({}, InputTheme, {
    Main: styled(InputTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "jab3ea-2"
    })(["pointer-events:none;height:100%;width:100%;"]),
    Input: styled(InputTheme.Input).withConfig({
      displayName: "theme__Input",
      componentId: "jab3ea-3"
    })(["height:100%;width:100%;"])
  }),
  FileInput: styled.input.withConfig({
    displayName: "theme__FileInput",
    componentId: "jab3ea-4"
  })(["position:absolute;top:0;left:0;opacity:0;pointer-events:none;width:100%;height:100%;"])
};
export default FileInputTheme;